import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-purchase',
  templateUrl: './delete-purchase.component.html',
  styleUrls: ['./delete-purchase.component.css']
})
export class DeletePurchaseComponent implements OnInit {

  data: any;

  modelSubtitle = false
  quantityArr:any = []
 checked = false

 i: any;
 deleteId: any = "";
  products: any = [];
  vendor: any = [];
  branch: any = [];
  materials: any = [];
  materialdata: any = [];

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;


 constructor( private toastr: ToastrService,private generic_service: GenericService) { }

ngOnInit(): void {
  this.getAllMaterial(this.pageNumber,this.recordsPerPage)
  }

cancelModel(){
  document.getElementById("closeModalButton1")?.click()
}

onTableDataChange(event: any) {
  this.pageNumber = event;
  this.getAllMaterial(this.pageNumber-1,this.recordsPerPage)
}


getAllMaterial(pageNumber:any,recordsPerPage:any){
  this.generic_service.getAllMaterial(pageNumber,recordsPerPage).subscribe(
    (response:any)=>{
      this.materials = response.response.materialPurchaseList;
      this.totalRecords = response.response.totalRecords;
      console.log(response)
    }
  )
}

// getMaterialById(id:any){
//   this.generic_service.getMaterialById(id).subscribe(
//     (response:any)=>{
//       this.materialdata = response.response;
//       console.log(response)
//     }
//   )
// }

getMaterialById(id:any){
  this.generic_service.getMaterialById(id).subscribe(
    (response:any)=>{
      console.log(response)
      console.log(response.response)
       
    },
    (error)=>{
      console.log(error)
 

    }
  )
}

checkPage(){
  let pageNumber = 0
  if(this.pageNumber == 0){
    pageNumber = this.pageNumber
  }else{
    pageNumber = this.pageNumber-1
  }
}

deleteMaterialPurchase(){
  this.generic_service.deleteMaterialPurchase(this.deleteId).subscribe(
  (res:any)=>{
    console.log(res)
    this.toastr.success("Successfully deleted");
    this.getAllMaterial(this.pageNumber,this.recordsPerPage)
    this.cancelModel();
  },err=>{
    console.log(err)
    this.toastr.error(err.error.errors[0].description);
  }
  )
}

del(id:any){
this.deleteId = id
}

 

}